export default class PaymentTransactions {
    static modelName = 'PaymentTransactions';
    id: number
    bookingId: number
    createDate: Date
    transactionAmount: number
    transactionStatus: string
    transactionErrorText: string
    paypalTransactionOrderId: string
}